var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post"},[_c('h3',{staticClass:"h3 title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"lead",domProps:{"innerHTML":_vm._s(_vm.lead)}}),_vm._v(" "),(_vm.has_content)?_c('a',{staticClass:"more",attrs:{"href":_vm.link}},[_vm._v("mehr Details"),_c('i',{staticClass:"icon-more"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }